import { Spinner } from "reactstrap";
import useColors from "../customHooks/useColors";

const LoadingAnimation = ({ ...props }) => {
  const [currentColors] = useColors();

  const styles = {
    loadingDiv: {
      display: "flex",
      flexDirection: "column",
    },
    spinnerDiv: {
      display: "flex",
      flexDirection: "row",
      gap: "10px",
    },
    spinner: {
      color: "rgb(255,255,255)",
      height: "14px",
      width: "14px"
      
    },
  };
  let stylesToApply = props.style ?? {};

  return (
    <div style={{ ...styles.loadingDiv, ...stylesToApply }}>
      <div style={styles.spinnerDiv}>
        <Spinner type="grow" style={styles.spinner} />
        <Spinner type="grow" style={styles.spinner} />
        <Spinner type="grow" style={styles.spinner} />
      </div>
    </div>
  );
};

export default LoadingAnimation;
